import Router from 'vue-router';
import currentSubsidiaryStorage from '@/shared/current-subsidiary';
import login from './login';
import customers from './customers';
import customersEdit from './customers-edit';
import customersNew from './customers-new';
import accountDefinitions from './account-definitions';
import companies from './companies';
import companiesNew from './companies-new';
import companiesEdit from './companies-edit';
import accountant from './accounting-plans';
import rules from './rules';
import accountingParametrization from './accounting-parametrization';
import accountingPeriods from './accounting-periods';
import accountingRulesNew from './accounting-rules-new';
import modules from './modules';
import accountingAccounts from './accounting-accounts';
import dictionary from './dictionary';
import costCenters from './cost-centers';
import accountingRulesEdit from './accounting-rules-edit';
import journal from './journal';
import records from './records';
import recordsDetail from './records-detail';
import ledger from './ledger';
import components from './components';
import accountingAccountsBySubsidiary from './accounting-accounts-by-subsidiary';
import accountingAction from './accouting-action';
import newCostCenters from './new-cost-center';
import editAccounting from './edit-accounting';
import main from './main';
import statistics from './statistics';
import reports from './reports';
import templates from './company-templates';
import atsSales from './ats-sales';
import atsRules from './ats-rules';
import atsRulesNew from './ats-rules-new';
import rulesAtsEdit from './rules-ats-edit';
import atsListDictionary from './ats-list-dictionary';
import atsDictionary from './ats-dictionary';
import atsDefinitions from './ats-definitions';
import batchAccounting from './batch-accounting';
import accountingAnalysis from './accounting-analysis';
import syncOdoo from './sync-odoo';
import yourPlan from './your-plan';
import profile from './profile';
import users from './users';

// Pantallas contables que trabajan con la empresa elegida en Principal.
const COMPANY_ROUTES = [
	accountant,
	accountingAction,
	accountingAccounts,
	accountingAccountsBySubsidiary,
	accountingParametrization,
	accountingPeriods,
	accountingRulesNew,
	accountingRulesEdit,
	accountDefinitions,
	accountingAnalysis,
	batchAccounting,
	costCenters,
	newCostCenters,
	editAccounting,
	journal,
	ledger,
	modules,
	records,
	recordsDetail,
	reports,
	rules,
];

function routeNames(routes) {
	return routes.reduce((names, route) => {
		const own = route.name ? [route.name] : [];
		const children = route.children ? routeNames(route.children) : [];
		return names.concat(own, children);
	}, []);
}

const requiresCompany = new Set(routeNames(COMPANY_ROUTES));

// Sin empresa elegida (ni sucursal en la URL) se vuelve a Principal a elegirla.
function missingCompany(to) {
	if (!requiresCompany.has(to.name)) return false;
	const fromRoute = (to.params && to.params.subsidiaryId) || (to.query && to.query.subsidiaryId);
	return !fromRoute && !currentSubsidiaryStorage.read();
}

export default function (Vue) {
	Vue.use(Router);
	const config = new Router({
		mode: 'history',
		routes: [
			{
				path: '/',
				name: 'page-home',
				redirect: '/main',
				children: [
					atsListDictionary,
					atsDictionary,
					atsDefinitions,
					accountant,
					accountingAction,
					accountingAccounts,
					accountingParametrization,
					accountingPeriods,
					accountingRulesNew,
					customers,
					customersEdit,
					customersNew,
					dictionary,
					accountDefinitions,
					companies,
					companiesNew,
					companiesEdit,
					modules,
					rules,
					costCenters,
					accountingRulesEdit,
					journal,
					records,
					recordsDetail,
					ledger,
					accountingAccountsBySubsidiary,
					newCostCenters,
					editAccounting,
					main,
					statistics,
					reports,
					templates,
					atsRules,
					atsSales,
					atsRulesNew,
					rulesAtsEdit,
					batchAccounting,
					accountingAnalysis,
					syncOdoo,
					yourPlan,
					profile,
					...users,
				],
				component: () => import('@/pages/page-home'),
			},
			login,
			components,
		],
	});

	config.beforeEach(async (to, from, next) => {
		if (to.name !== 'login') {
			if (to.query && (to.query.password || to.query.email)) {
				// Remove legacy credential links without exchanging credentials or calling fixed hosts.
				return next({ name: 'login', query: {}, replace: true });
			}

			const token = window.localStorage.getItem(`${process.env.STORAGE_USER_KEY}::token`);
			if (token) {
				if (missingCompany(to)) {
					return next({ name: 'main', replace: true });
				}
				return next();
			}
			return next({ name: 'login' });
		}
		return next();
	});

	// 👇 NUEVO: actualiza el título de la pestaña en cada navegación
	config.afterEach((to) => {
		const defaultTitle = 'Quipu'; // 👈 cambia si quieres otro por defecto
		const title = to.meta && to.meta.title ? to.meta.title : defaultTitle;
		document.title = title;
	});

	return config;
}



// WEBPACK FOOTER //
// ./src/router/index.js